import applications from "./applications";

const applicationService = [
    {
        matcher: 'applications',
        reply: config => {
            return [200, applications];
        }
    },
    {
        matcher: /applications\/(.*)/,
        reply: config => {
            const no = /applications\/(.*)/.exec(config.url)[1];
            const application = applications.find(application => application.no === no);
            return [200, application];
        }
    }
]

export default  applicationService